import { fetchWithCookieAuth } from "../app/connection/cookieFetch";
import { isAtoAppProxySessionUrl } from "./launchClient";

/** Redeem once before mounting an iframe; the document and external links
 * then use the same host-only HttpOnly cookie and never replay the grant. */
export async function exchangeAppViewAccess(
  appUrl: string,
  signal: AbortSignal,
): Promise<string> {
  const url = new URL(appUrl);
  const token = url.searchParams.get("app_view_token");
  if (!token) return appUrl;
  if (!isAtoAppProxySessionUrl(appUrl) || url.username || url.password)
    throw new Error("Invalid app access origin");
  if (signal.aborted) throw new DOMException("Aborted", "AbortError");
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal.addEventListener("abort", abort, { once: true });
  const timeout = setTimeout(abort, 15_000);
  try {
    const endpoint = new URL("/__ato/app/access", url.origin);
    const response = await fetchWithCookieAuth(endpoint.href, {
      method: "POST",
      headers: { authorization: `Bearer ${token}` },
      cache: "no-store",
      referrerPolicy: "no-referrer",
      redirect: "error",
      signal: controller.signal,
    });
    if (!response.ok) throw new Error("App access exchange failed");
    url.searchParams.delete("app_view_token");
    return url.href;
  } finally {
    clearTimeout(timeout);
    signal.removeEventListener("abort", abort);
  }
}
